import { ApplicationState } from "../../store/store";

export const getCurrentUser = (state: ApplicationState) => state.account.user;
export const isAuthenticatedSelector = (state: ApplicationState) => state.account.isAuthenticated;
export const isSessionLoaded = (state: ApplicationState) => state.account.isSessionLoaded;
export const getUserName = (state: ApplicationState) =>
    state.account.user ? `${state.account.user.firstName} ${state.account.user.lastName}` : "";
